module.exports = __webpack_public_path__ + "216ce553de689c49b33f5507295715e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/nature/Snow3.jpg
// module id = 3550
// module chunks = 0